var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAudio = function SvgAudio(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-14": 11,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-32": 24,
    "data-width-36": 27,
    "data-width-40": 30,
    viewBox: "0 0 11.8 11.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.28 0a1.83 1.83 0 0 1 1.333.54l2.547 2.546a1.83 1.83 0 0 1 .54 1.334v5.746a1.5 1.5 0 0 1-.949 1.396 1.5 1.5 0 0 1-.584.104H1.5a1.5 1.5 0 0 1-1.5-1.5V1.5A1.5 1.5 0 0 1 1.5 0zM1.5 1a.507.507 0 0 0-.5.5v8.666a.507.507 0 0 0 .5.5h8.667a.507.507 0 0 0 .5-.5V4.387a.83.83 0 0 0-.247-.594L7.873 1.246A.84.84 0 0 0 7.28 1zm4.717 1.754A.502.502 0 0 1 7 3.166V8.5a.5.5 0 0 1-.783.413L4.123 7.476H2.5a.5.5 0 0 1-.5-.5V4.69l.01-.1a.5.5 0 0 1 .49-.4h1.623zm1.898 1.427a.5.5 0 0 1 .704-.065c.527.436.848 1.051.848 1.717s-.32 1.282-.848 1.72a.5.5 0 0 1-.638-.771c.326-.27.486-.615.486-.949s-.16-.678-.486-.948a.5.5 0 0 1-.066-.704m-3.554.922a.5.5 0 0 1-.284.087H3v1.286h1.277l.076.006q.112.018.208.082L6 7.55V4.116z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAudio);
export default ForwardRef;